"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graph_1 = __importDefault(require("./gen/graph"));
const graphConstants = {
    enums: graph_1.default
};
exports.default = graphConstants;
//# sourceMappingURL=graph.js.map